const FALLBACK_FILENAME = 'reports.csv';

export function downloadBlob(blob: Blob, filename: string | null): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename && filename.trim() !== '' ? filename : FALLBACK_FILENAME;
  anchor.click();
  // Revoke on a deferred tick rather than synchronously in `finally` --
  // some browsers kick off the actual download asynchronously off the
  // click, and revoking the URL immediately can race it and cancel the
  // save. A macrotask is plenty of headroom for that to have started.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
